import { render, staticRenderFns } from "./OntarioIDv1Form.vue?vue&type=template&id=2d988a2d&scoped=true&"
import script from "./OntarioIDv1Form.vue?vue&type=script&lang=ts&"
export * from "./OntarioIDv1Form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d988a2d",
  null
  
)

export default component.exports